export default {
  styleOverrides: {
    root: {
      color: "secondary"
    }
  }
}